<template>
    <div ref="mainHigh" class="mianLogin">
        <div class="logoTop">
            <div class="imgs">
               <img src="./img/logo_notext.png" alt="">
            </div>
            <h3>高企助手</h3>
        </div>
        <a-button class="subtn" size="large" type="primary"  @click="submit()">手机号一键登录</a-button>
        <span class="subtn" style="margin-top:-.5rem;background:none" @click="goMore('/webHighEnterpriseEvaluation/login') ">输入手机号登录/注册</span>
    </div>
  </template>
  
  <script>
  export default {
    
    data () {
        return {
            captcha:null,
        }
    },
    mounted() {
      this.$refs.mainHigh.style.height = window.innerHeight+'px'
      this.generateCaptcha();//验证码
    },
    methods: {
        submit(){
            this.goMore('/webHighEnterpriseEvaluation?bottom_nav_ico=1&loginStatus=1') 
        },
        //路由跳转
        goMore(url, str) {
            if(str){
                this.$router.push({ path: url, query: { id: str } })
            }else{
                this.$router.push(url)
            }
        },
        
    }
  };
  </script>
  <style lang="less" scoped>
  .mianLogin{
    font-family: '微软雅黑';
    width:100%;
    background: url(./img/bg.jpg) no-repeat;
    background-size: 100% 100%;
    display: flex;
    font-size: 1.1rem;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    .logoTop{
        width:80vw;
        display: flex;
        flex-direction: column;
        align-items: center;
        margin-bottom:2rem;
        font-weight: bold;
        .imgs{
            border-radius: 8rem;
            width:8rem;
            height:8rem;
            background: #fff;
            display: flex;
            align-items: center;
            justify-content: center;
            margin-bottom:.5rem;
        }
    }
    
    .subtn{
        width:80vw;
        margin-top:2rem;
        padding:.8rem 0 2.4rem;
        font-size: 1.1rem;
        background: #1c4ff7;
        text-align: center;
    }
  }
  </style>